import * as React from 'react';
import NavigatorNew from '../Navigator/NavigatorNew';

function NavigatorContainer() {
  return <NavigatorNew />;
}

export default NavigatorContainer;
